import { TCreateSendLinkActionTarget } from '../../../types/createSendLinkAction';

export const CS_LINK_ACTION_REQUESTED = 'CS_LINK_ACTION_REQUESTED';

export const csLinkActionRequested = (payload: { target: TCreateSendLinkActionTarget }) => ({
  type: CS_LINK_ACTION_REQUESTED,
  payload,
});
